import React, { useContext, useState, useRef, useEffect } from "react";
import { CartContext } from "../../context/CartContext";
import ProductInfoModal from "../Modals/ProductInfoModal";
import { FaShoppingCart } from "react-icons/fa";
import { addToCartAndOrderExpress } from "../../utils/addToCartAndOrderExpress";
import MonthlyCustomerChart from "../Charts/MonthlyCustomerChart";
import { getMyAccountId } from "../../utils/config";
import { Link } from "react-router-dom";
import { API_BASE } from "../../utils/api";
import { useFloating, autoUpdate, offset, flip, shift, useHover, useInteractions, arrow, FloatingArrow } from '@floating-ui/react';

export default function
  ProductCard({ product,
    t,
    fontSize = "text-[12px]",
    px = "px-1",
    highlighted = false,
    categoryId,
    selectedGroups,
    currentPage,
    hasProdFreq
  }) {
  const {
    idProduct,
    productId,
    productName,
    unitPrice,
    sugestedQty,
    ordenNo,
    firstDate,
    lastDate,
    cuantas,
    acuerdo,
  } = product;

  const MYACCOUNT_ID = getMyAccountId();
  const user = JSON.parse(localStorage.getItem("user"));
  const [isProformaMode, setIsProformaMode] = useState(
    () => localStorage.getItem("order_mode") === "proforma"
  );
  const { addToCart, updateCartItem } = useContext(CartContext);

  useEffect(() => {
    const sync = () => setIsProformaMode(localStorage.getItem("order_mode") === "proforma");
    window.addEventListener("orderModeChange", sync);
    return () => window.removeEventListener("orderModeChange", sync);
  }, []);

  const [qty, setQty] = useState(sugestedQty ? Number(sugestedQty) : 1);
  const [inputVal, setInputVal] = useState(String(sugestedQty ? Number(sugestedQty) : 1));
  const [infoOpen, setInfoOpen] = useState(false);
  const [infoProduct, setInfoProduct] = useState(null);
  const [monthlyData, setMonthlyData] = useState([]);
  const [loadingChart, setLoadingChart] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const arrowRef = useRef(null);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: (open) => {
      setIsOpen(open);
      if (open) loadMonthlyStats();
    },
    placement: "right",
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(75),
      flip({ padding: 10 }),
      shift({ padding: 10 }),
      arrow({ element: arrowRef }),
    ],
  });

  const hover = useHover(context, { move: false, delay: 100 });
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  const handleAddToCart = () => {
    addToCartAndOrderExpress({
      product, qty, user, addToCart, updateCartItem,
      openInfoModal: (p) => { setInfoProduct(p); setInfoOpen(true); },
    });
  };

  const handleOpenModal = () => {
    const productForModal = {
      img: `https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${String(productId).trim()}.jpg`,
      productName: productName,
      productId: productId,
      price: unitPrice,
      qty: qty,
      payTax: product.payTax || false,
      service: product.service,
      idProduct: idProduct,
      unitPrice: unitPrice,
      acuerdo: product.acuerdo,
      categoryId: product.categoryId,
    };
    setInfoProduct(productForModal);
    setInfoOpen(true);

  };


  const loadMonthlyStats = async () => {
    setLoadingChart(true);
    try {
      const res = await fetch(`${API_BASE}/inventary-ultra/api/ws/pr_month_customers?id_customer=${user.idCustomer}&id_ship_to=${user.idShipTo || 0}&id_product=${idProduct}`);
      const json = await res.json();
      setMonthlyData(json || []);
    } catch (err) {
      setMonthlyData([]);
    } finally {
      setLoadingChart(false);
    }
  };

  const isHighlighted = highlighted && sugestedQty !== null && sugestedQty !== undefined;

  const handleQtyChangeFromModal = (newQty) => updateCartItem(idProduct, newQty);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
  };

  return (
    <>
      <div
        className={`relative rounded-xl transition-all duration-300 flex flex-col h-full
        ${isHighlighted
            ? "bg-white border border-brand-primary shadow-sm  p-1"
            : "bg-white border border-gray-200 shadow-sm hover:shadow-md  p-1"
          }`}
      >

        {/* BADGE DESTACADO */}
        {isHighlighted && (
          <div className="absolute -top-3 right-2 z-10 bg-brand-primary text-white text-[10px] px-2 py-1 rounded-md font-medium shadow-sm">
            Producto frecuente
          </div>
        )}

        {/* IMAGEN */}
        {ordenNo && (
          <div className="absolute top-2 left-2 bg-white text-gray-900 text-base px-3 py-1.5 rounded-xl shadow-lg border border-gray-200 z-10 flex items-center gap-2">
            <span className="text-gray-900 text-lg font-bold">{ordenNo}</span>
          </div>
        )}
        <div className="w-full h-48 flex items-center justify-center mb-0 relative shrink-0 overflow-hidden rounded-t-xl">
          {/* ETIQUETA IVA - pill (solo se marca la excepcion: productos exentos) */}
          {user && !product.payTax && (
            <div className="absolute top-0 right-0 bg-amber-500 text-white text-[11px] font-bold px-2 py-1 rounded-md shadow-sm z-10 whitespace-nowrap">
              Exento de IVA
            </div>
          )}

          <Link
            to={{
              pathname: `/product/${idProduct}`,
              state: { qty }
            }}
            onClick={() => {
              // Si viene de productos frecuentes (categoryId === "frequent")
              if (categoryId === "frequent") {
                sessionStorage.setItem("last_section", "frequent_products");
                sessionStorage.setItem("frequent_products_page", currentPage);
              } else {
                // Si viene de categorías normales
                sessionStorage.setItem("last_section", "category_page");
                sessionStorage.setItem("last_category_page", currentPage);
                sessionStorage.setItem("last_has_prod_freq", hasProdFreq);
                sessionStorage.setItem("last_category_id", categoryId);
                sessionStorage.setItem("last_selected_group", selectedGroups || "");
              }
            }}
          >
            <img
              src={`https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${String(productId).trim()}.jpg`}
              alt={productName}
              className="max-h-full max-w-full object-contain cursor-pointer hover:scale-105 transition"
              onError={(e) => {
                e.preventDefault();
                e.stopPropagation();
                e.currentTarget.onerror = null;
                e.currentTarget.src = "https://www.ultra-erp.pro/products/no_image.jpg";
              }}
              loading="eager"
              decoding="async"
            />
          </Link>
        </div>

        {/* NOMBRE */}
        <div className="h-14 flex items-center justify-center mb-2">
          <h5 className={`${fontSize} ${px} text-center font-bold text-gray-900 line-clamp-4 leading-tight uppercase`}>
            {productName}
          </h5>
        </div>

        {/* CÓDIGO */}
        <div className="h-5 flex items-center justify-center mb-1">
          <span className="text-sm text-center text-gray-600">
            <span className="font-semibold text-gray-500">Código:</span> {productId}
          </span>
        </div>

        {/* PRECIO */}
        {user && (
          <div className="flex flex-col items-center justify-center mb-1">
            <p className="text-lg text-center font-bold text-brand-primary">
              ${Number(unitPrice).toFixed(4)}
            </p>
          </div>
        )}

        {/* CANTIDAD */}
        {user && (
          <div className="flex justify-center items-center gap-3 mb-3">
            <div
              {...(sugestedQty ? getReferenceProps() : {})}
              ref={sugestedQty ? refs.setReference : null}
              className={`flex flex-col text-xs leading-tight text-right ${sugestedQty ? "cursor-help" : "cursor-default"
                } ${highlighted && sugestedQty
                  ? "bg-brand-primary text-white px-2 py-1 rounded-md shadow-sm"
                  : "text-gray-500"
                }`}
            >
              <span
                className={`font-medium ${highlighted && sugestedQty ? "text-white" : "text-gray-700"
                  }`}
              >
                Cantidad
              </span>

              {sugestedQty && (
                <span
                  className={`font-medium ${highlighted ? "text-white/90" : "text-gray-700"
                    }`}
                >
                  sugerida
                </span>
              )}
            </div>

            <input
              type="number"
              min="1"
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              onBlur={(e) => {
                const n = Math.max(1, Number(e.target.value) || 1);
                setQty(n);
                setInputVal(String(n));
              }}
              onFocus={(e) => e.target.select()}
              className="w-20 h-10 border border-gray-300 rounded-lg px-2 py-1 text-base text-center focus:ring-2 focus:ring-brand-primary outline-none"
            />
          </div>
        )}

        {/* BOTÓN */}
        {user && (
          <div className="mt-auto">
            <button
              className={`${fontSize} w-full py-2.5 rounded-lg font-semibold hover:brightness-90 transition flex items-center justify-center gap-2 ${isProformaMode ? "bg-[#FFFFB3] text-black" : "bg-[#80FF80] text-black"}`}
              onClick={handleOpenModal}
            >
              <FaShoppingCart className="text-base" />
              {isProformaMode ? "Agregar a Solicitud de Proforma" : "Agregar a Orden"}
            </button>
          </div>
        )}

        {/* TOOLTIP */}
        {isOpen && (firstDate || lastDate || cuantas !== undefined) && (
          <div ref={refs.setFloating} style={{ ...floatingStyles, zIndex: 9999 }} {...getFloatingProps()}>
            <div className="bg-white text-gray-900 text-sm rounded-xl shadow-2xl p-4 w-[420px] max-w-[90vw] border border-gray-200 flex items-center gap-4 relative">
              <FloatingArrow ref={arrowRef} context={context} fill="white" stroke="#e5e7eb" strokeWidth={1} />
              <div className="flex-none w-32 border-r border-gray-100 pr-4 space-y-2 text-left">
                {firstDate && (
                  <div className="flex flex-col">
                    <span className="text-gray-500 text-[10px]">Primera Orden:</span>
                    <span className="font-semibold text-gray-800 text-[11px] leading-none">{formatDate(firstDate)}</span>
                  </div>
                )}
                {lastDate && (
                  <div className="flex flex-col">
                    <span className="text-gray-500 text-[10px]">Última Orden:</span>
                    <span className="font-semibold text-gray-800 text-[11px] leading-none">{formatDate(lastDate)}</span>
                  </div>
                )}
                {cuantas && (
                  <div className="pt-1">
                    <span className="text-gray-500 text-[10px]">No. de Ordenes:</span>
                    <p className="font-semibold text-gray-800 leading-none">{cuantas}</p>
                  </div>
                )}
              </div>
              <div className="flex-1 h-32 flex flex-col justify-center min-w-0 overflow-hidden">
                <div className="absolute -top-2 left-28 bg-white text-gray-900 text-base px-3 py-1 rounded-lg shadow-md border border-gray-200 z-10 font-bold">
                  {ordenNo}
                </div>
                {loadingChart ? (
                  <div className="text-center text-xs animate-pulse text-brand-primary">Cargando...</div>
                ) : monthlyData?.length > 0 ? (
                  <>
                    <p className="text-[10px] font-bold text-gray-400 text-center mb-0">Últimos 12 meses</p>
                    <MonthlyCustomerChart data={monthlyData} />
                  </>
                ) : (
                  <div className="text-center text-gray-400 text-[10px] italic">Sin historial.</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <ProductInfoModal
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        product={infoProduct || idProduct}
        onQtyChange={handleQtyChangeFromModal}
        user={user}
      />
    </>
  );
}